function changeSelectedCategory(type) {
  const recipesList = document.getElementById("recipes-list");
  const breakfast = document.getElementById("recipe-category-breakfast");
  const entree = document.getElementById("recipe-category-entree");
  const snack = document.getElementById("recipe-category-snacks");
  const dessert = document.getElementById("recipe-category-dessert");

  switch (type) {
    case "breakfast":
      breakfast.classList.add("active");
      entree.classList.remove("active");
      snack.classList.remove("active");
      dessert.classList.remove("active");

      // Adding Breakfast Recipes
      recipesList.innerHTML = ``;

      // var breakfast_accordions = document.getElementsByClassName(
      //   "accordion-breakfast"
      // );

      // const hideBreakfastAccordion = () => {
      //   var accordions_content = document.getElementsByClassName(
      //     "accordion-content-breakfast"
      //   );
      //   for (var i = 0; i < accordions_content.length; i++) {
      //     accordions_content[i].style.maxHeight = null;
      //   }
      // };

      // for (var i = 0; i < breakfast_accordions.length; i++) {
      //   breakfast_accordions[i].onclick = function () {
      //     hideBreakfastAccordion();
      //     var content = this.nextElementSibling;
      //     if (content.style.maxHeight) {
      //       content.style.maxHeight = null;
      //     } else {
      //       content.style.maxHeight = content.scrollHeight + "px";
      //     }
      //   };
      // }
      break;
    case "entree":
      entree.classList.add("active");
      breakfast.classList.remove("active");
      snack.classList.remove("active");
      dessert.classList.remove("active");

      // Adding Entree Recipes
      recipesList.innerHTML = `<div class="entree-recipes">
<h4 class="accordion-entree">LITTLE MILLET SOUP</h4>
<div class="accordion-content-entree">
<img
src="https://cdn.shopify.com/s/files/1/0249/6233/4754/files/Millet_Soup_a0b3abe6-508e-45b5-9397-2175f24bae6d.jpg?v=1590707752"
alt="Little Millet Soup"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>Little Millet Flour - 1/4 cup</li>
<li>Yogurt - 1 cup</li>
<li>Water - 3.5 cup</li>
<li>Sugar - 1 tsp</li>
<li>Corn - 1/4 cup boiled</li>
<li>Mixed color Bell Peppers chopped - 3 tbsp</li>
<li>Carrots finely chopped - 2 tbsp</li>
<li>Cilantro finely chopped - 1 cup</li>
<li>Ghee - 3 tsp</li>
<li>Cumin seeds - 1/2 tsp</li>
<li>Black pepper - 1/2 tsp (freshly crushed)</li>
<li>Green chillies - 1 or 1/2 (optional)</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
Mix Flour and yogurt until it is smooth. Add water and salt. Stir
constantly to avoid lumps. Slightly fry Chopped veggies in ghee in a
saucepan. Pour the mixture into large saucepan and bring it to boil. Keep
stirring to avoid curdling. Turn the flame low-medium and simmer for at
least 15-20 mins or until it thickens. Adjust the salt and pepper, add
sugar and vegetables. Mix it together and turn off the flame. Garnish with
cilantro. Millet soup is ready to serve. If it gets too thickened, you can
add hot water to make it to serving consistency.
</p>
</div>
<h4 class="accordion-entree">KODO MILLET BISI BELE BATH</h4>
<div class="accordion-content-entree">
<img
src="https://cdn.shopify.com/s/files/1/0249/6233/4754/files/Kodo_Millet_Bisi_bella_bath.jpg?v=1590859549"
alt="KODO MILLET BISI BELE BATH"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>Kodo Millet (soaked overnight) - 1 cup</li>
<li>Toor Dal - 3/4 cup</li>
<li>Carrots, Beans, Zucchini, Potato & Drum sticks - As required</li>
<li>Salt - As required</li>
<li>Tamarind Juice - As required</li>
<li>Coriander seeds - 1/4 cup</li>
<li>Urad Dal - 1/4 cup</li>
<li>Chana Dal - 1/4 cup</li>
<li>Dried Chillies - 8</li>
<li>Poppy seeds - 1 tbsp</li>
<li>Black Pepper - 1 tsp</li>
<li>Hing & Turmeric - a pinch</li>
<li>Cinnamon - 2 sticks</li>
<li>Dry Coconut - 1/2 cup</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
Boil Toor dal in 2 cups of water and add pinch of Turmeric to it. Once
it's half cooked, add all the vegetables & salt and keep cooking. Now add
the Kodo millet and keep cooking for about 10 mins. Dry roast the masala
ingredients and crush to powder. Grind 3 tbsp of this powder and grind
with grated coconut. In a pan add ghee, masala powder, mustard seeds,
curry leaves and tamarind juice and let it boil. Transfer it to the
cooking millet and add water for consistency. Let it cook in simmer for 5
mins. Garnish with curry leaves, boondi and serve hot.
</p>
</div>
<h4 class="accordion-entree">MILLET STIR-FRY WITH VEGETABLES</h4>
<div class="accordion-content-entree">
<img
src="https://cdn.shopify.com/s/files/1/0509/7993/0283/files/Millet-stir-fry-with-vegetables.jpg?v=1622106631"
alt="MILLET STIR-FRY WITH VEGETABLES"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>
1 cup
<a href="/products/pearled-little-millet">Bliss Tree’s little millet</a>
</li>
<li>2 cups of water</li>
<li>
1 tablespoon
<a href="/products/cold-pressed-peanut-oil">Bliss Tree’s Peanut Oil</a>
</li>
<li>2 cloves garlic minced</li>
<li>1-inch ginger grated</li>
<li>1 green chili slit</li>
<li>1 onion chopped</li>
<li>
1 cup chopped mixed vegetables i.e carrots, french beans, red and green
bell pepper
</li>
<li>
1 large head broccoli, cut into florets A handful of asparagus, tough
ends snapped off and sliced into 2-inch pieces
</li>
<li>1 tsp turmeric powder</li>
<li>2 tsp cumin powder</li>
<li>1 tsp coriander powder</li>
<li>Salt to taste</li>
<li>
1/2 tsp
<a href="/products/garam-masala">Bliss Tree’s Garam Masala Powder</a>
</li>
<li>Chopped fresh cilantro and red pepper flakes (For Garnish)</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
Wash the millet in a fine sieve under running water. Soak for 10 mins
while you prepare the vegetables.
</p>
<p>
Heat peanut oil or vegetable oil in a pan. When the oil is hot, add
garlic, green chili, and ginger. Sauté for a minute.
</p>
<p>
Now add chopped onions, other vegetables, and 1 tsp turmeric powder, 2 tsp
cumin powder, 1 tsp coriander powder, salt to taste. Mix well and cook for
2 minutes.
</p>
<p>
Drain the millet and add to the pan. Add 2 cups of water (you can also use
vegetable stock for added flavor) and cook on medium-high heat till there
is a boil.
</p>
<p>
Reduce the heat to low and cook covered, with a little opening, till all
the water is absorbed and the millet is cooked through.
</p>
<p>
Your millet stir-Fry with vegetable fry is ready to serve. Garnish it with
some fresh cilantro leaves, a sprinkle of red pepper flakes.
</p>
</div>
<h4 class="accordion-entree">MILLET VEGGIE BURGER RECIPE</h4>
<div class="accordion-content-entree">
<img
src="https://cdn.shopify.com/s/files/1/0509/7993/0283/files/RidiculouslyHealthyMilletBurgers3676.jpg?v=1624359535"
alt="MILLET VEGGIE BURGER RECIPE"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>1 1/2 cup water</li>
<li>1 large onion, finely chopped</li>
<li>2 small zucchinis</li>
<li>2 stalks celery, minced</li>
<li>2 finely grated carrot</li>
<li>2 tsp. sea salt</li>
<li>1 tablespoon chopped parsley</li>
<li>1 teaspoon chopped thyme</li>
<li>1 T. cumin</li>
<li>1 clove minced garlic</li>
<li>1/2 tsp. Bliss Tree chili powder</li>
<li>1/4 teaspoon ground pepper</li>
<li>
1 tablespoon
<a href="/products/cold-pressed-coconut-oil"
>Bliss Tree extra-virgin coconut oil</a
>
</li>
<li>1 large egg, lightly whisked</li>
<li>
1 1/2 cups millet flour (<a href="/products/kodo-millet-flour"
>Bliss Tree Kodo Millet Flour</a
>/
<a href="/products/little-millet-flour"
>Bliss Tree Little Millet Flour</a
>/
<a href="/products/ragi-finger-millet-flour-1"
>Bliss Tree Ragi Millet Flour</a
>)
</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
In a large bowl, combine millet flour (Bliss Tree Kodo Millet Flour/ Bliss
Tree Little Millet Flour/ Bliss Tree Ragi Millet Flour), onion, garlic,
carrot, zucchini, celery, cumin, thyme, parsley, coconut oil and mix well.
Add egg and mix it well; season with salt, chili powder, and pepper.
</p>
<p>
Using a 1/2 cup dry measuring cup, scoop out millet mixture and lightly
pack. Turn out onto the work surface and flatten to make a burger patty.
Repeat the process for making more burgers.
</p>
<p>
Heat a large skillet over medium-high heat. Add Bliss Tree Extra Virgin
Coconut Oil. When the oil is heated, add burger patty, working in batches
if necessary. Cook, gently turning once, until a golden crust has formed
on the bottom, 8 to 10 minutes per side. Alternatively, the burgers may be
baked in a 375-degree oven on a baking sheet for 30 minutes.
</p>
<p>Serve on hamburger buns with lettuce, tomato, and a dollop of mayo.</p>
</div>
</div>
`;

      var entree_accordions =
          document.getElementsByClassName("accordion-entree");

      const hideEntreeAccordion = () => {
        var accordions_content = document.getElementsByClassName(
          "accordion-content-entree"
        );
        for (var i = 0; i < accordions_content.length; i++) {
          accordions_content[i].style.maxHeight = null;
        }
      };

      for (var i = 0; i < entree_accordions.length; i++) {
        entree_accordions[i].onclick = function () {
          // hideEntreeAccordion();
          var content = this.nextElementSibling;
          if (content.style.maxHeight) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        };
      }
      break;
    case "snack":
      snack.classList.add("active");
      breakfast.classList.remove("active");
      entree.classList.remove("active");
      dessert.classList.remove("active");

      // Adding Snack Recipes
      recipesList.innerHTML = `<div class="snacks-recipes">
<h4 class="accordion-snacks">LITTLE MILLET MURUKKU/CHAKALI</h4>
<div class="accordion-content-snacks">
<img
src="https://cdn.shopify.com/s/files/1/0249/6233/4754/files/IMG-20200527-WA0000_5962cd62-74b4-4630-bbca-592960d94389.jpg?v=1590707612"
alt="LITTLE MILLET MURUKKU/CHAKALI"
/>
<p class="accordion-recipe-title">Ingredients</p>
<ul>
<li>Little Millet Flour - 1 cup</li>
<li>Besan - 1/2 cup</li>
<li>Hot Oil or Butter - 1 tsp</li>
<li>Salt - As required</li>
<li>Chili Powder - As required</li>
<li>Sesame seeds - As required</li>
<li>Water - As required</li>
</ul>
<br />
<p class="accordion-recipe-title">Instructions</p>
<p>
Mix all ingredients to form a semi-thick consistency and leave it for an hour. Use Murukku maker to press and deep fry.
</p>
</div>
</div>`;

      var snacks_accordions =
          document.getElementsByClassName("accordion-snacks");

      const hideSnacksAccordion = () => {
        var accordions_content = document.getElementsByClassName(
          "accordion-content-snacks"
        );
        for (var i = 0; i < accordions_content.length; i++) {
          accordions_content[i].style.maxHeight = null;
        }
      };

      for (var i = 0; i < snacks_accordions.length; i++) {
        snacks_accordions[i].onclick = function () {
          // hideSnacksAccordion();
          var content = this.nextElementSibling;
          if (content.style.maxHeight) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        };
      }
      break;
    case "dessert":
      dessert.classList.add("active");
      snack.classList.remove("active");
      breakfast.classList.remove("active");
      entree.classList.remove("active");

      // Adding Dessert Recipes
      recipesList.innerHTML = "";
      break;

    default:
      console.log("Error!");

      // Adding No Recipes
      recipesList.innerHTML = "";
      break;
  }
}
function breakfastListener() {
  changeSelectedCategory("breakfast");
}
function entreeListener() {
  changeSelectedCategory("entree");
}
function snackListener() {
  changeSelectedCategory("snack");
}
function dessertListener() {
  changeSelectedCategory("dessert");
}